// extracted by mini-css-extract-plugin
export const atlasGrotesk = "'AtlasGrotesk'";
export const bold = "700";
export const contentWrapper = "Login__contentWrapper__rSTsk";
export const headBgColorExternal = "var(--salt)";
export const headBgColorInternal = "var(--shade)";
export const headBgColorShrunkSidebar = "var(--slate)";
export const medium = "500";
export const onboardingInvitation = "Login__onboardingInvitation__vYbWH font-faces__sansRegular__c8KXl font-faces__sans__uCf65";
export const onboardingLink = "Login__onboardingLink__VE80h";
export const regular = "400";
export const sans = "'sans'";
export const semibold = "600";
export const serif = "'serif'";